module.exports = __webpack_public_path__ + "static/image/main/card/image-13.ver2_0_2.png?e4f1238c";